export const GET_PREOFFER_DATA_REQUEST = 'GET_PREOFFER_DATA_REQUEST'
export const GET_PREOFFER_DATA_RECEIVE = 'GET_PREOFFER_DATA_RECEIVE'
export const SUBMIT_PREOFFER_DATA_REQUEST = 'SUBMIT_PREOFFER_DATA_REQUEST'
export const CHECK_PREOFFER_COMPLETED_REQUEST = 'CHECK_PREOFFER_COMPLETED_REQUEST'
export const CHECK_PREOFFER_COMPLETED_RECEIVE = 'CHECK_PREOFFER_COMPLETED_RECEIVE'